const home = {
  hero_badge: 'Gesundheitstourismusplattform der Türkei',
  hero_title_1: 'Werden Sie',
  hero_title_2: 'Gesund',
  hero_title_3: 'in der Türkei',
  hero_subtitle: 'Entdecken Sie akkreditierte Gesundheitseinrichtungen der Türkei für Patienten aus dem Ausland. Planen Sie Ihre Reise selbst oder überlassen Sie die gesamte Organisation einer Vermittlungsagentur.',
  hero_stat_institutions: 'Akkreditierte Einrichtungen',
  hero_stat_patients: 'Zufriedene Patienten',
  hero_stat_doctors: 'Fachärzte',
  hero_stat_countries: 'Länder',
  hero_accreditation_label: 'Akkreditierung:',
  hero_search_title: 'Behandlung suchen',
  hero_step1_label: 'Behandlungsart',
  hero_step1_placeholder: 'Behandlung eingeben oder auswählen...',
  hero_step2_label: 'Organisationspräferenz',
  hero_self_organize: 'Ich kann die Reise selbst organisieren',
  hero_agency_organize: 'Eine Agentur soll mein Krankenhaus & meine Reise organisieren',
  hero_step3_agency: 'Vermittlungsagentur',
  hero_step3_institution: 'Gesundheitseinrichtung',
  hero_step3_optional: '(optional)',
  hero_all_agencies: 'Alle Agenturen anzeigen',
  hero_all_institutions: 'Alle Einrichtungen anzeigen',
  hero_city_label: 'Stadt',
  hero_all_cities: 'Alle Städte',
  hero_search_agencies: 'Agenturen erkunden',
  hero_search_institutions: 'Gesundheitseinrichtungen erkunden',
  hero_trust_note: 'Alle Einrichtungen sind vom türkischen Gesundheitsministerium genehmigt',

  steps_title: '3 Schritte zur Plattformnutzung',
  steps_subtitle: 'Die richtige Gesundheitseinrichtung zu finden ist jetzt viel einfacher',
  step1_number: 'Schritt 1',
  step1_title: 'Kostenlos registrieren',
  step1_desc: 'Registrieren Sie sich kostenlos auf der Plattform und erhalten Sie sofortigen Zugang zu allen Funktionen',
  step2_number: 'Schritt 2',
  step2_title: 'Einrichtungen durchsuchen',
  step2_desc: 'Vergleichen Sie akkreditierte Gesundheitseinrichtungen, überprüfen Sie Ärzte und Dienstleistungen',
  step3_number: 'Schritt 3',
  step3_title: 'Rückrufanfrage senden',
  step3_desc: 'Senden Sie eine Rückrufanfrage an Ihre gewählte Einrichtung, sie werden Sie in Ihrer Sprache anrufen',

  treatment_badge: 'Behandlungsbereiche',
  treatment_title: 'Beliebteste',
  treatment_title_highlight: 'Behandlungen in der Türkei',
  treatment_subtitle: 'Tausende internationale Patienten wählen jedes Jahr die Türkei. Entdecken Sie akkreditierte Einrichtungen in den folgenden Behandlungsbereichen.',
  treatment_view_institutions: 'Einrichtungen anzeigen',
  treatment_view_all: 'Alle Behandlungsbereiche anzeigen',

  institutions_title: 'Gesundheits-',
  institutions_title_highlight: 'einrichtungen',
  institutions_subtitle: 'Finden Sie die am besten geeignete unter den genehmigten Gesundheitseinrichtungen',
  institutions_view_all: 'Alle Einrichtungen anzeigen',
  institutions_empty: 'Noch keine genehmigten Einrichtungen.',
  agencies_badge: 'Organisation & Reisedienstleistungen',
  agencies_title: 'Gesundheitstourismus-',
  agencies_title_highlight: 'Agenturen',
  agencies_subtitle: 'Agenturen, die Ihren Gesundheitsservice zusammen mit Ihren Reise-, Unterkunfts- und Tourismusbedürfnissen organisieren',
  agencies_view_all: 'Alle Agenturen anzeigen',
  agencies_empty_title: 'Noch keine Agenturen',
  agencies_empty_desc: 'Agenturen werden bald aufgelistet.',
  agency_label: 'Agentur',
  consultation_available: 'Beratungsanfrage kann gesendet werden',
  service_flight: 'Flug & Transfer',
  service_hotel: 'Hotelreservierung',
  service_tour: 'Touristentour',
  service_translation: 'Übersetzung',
  service_vip: 'VIP-Empfang',

  why_title: 'Warum',
  why_title_highlight: 'Uns wählen?',
  why_subtitle: 'Ihr vertrauenswürdiger Leitfaden für internationale Patienten, die in der Türkei Gesundheitsversorgung suchen',
  why_stat_institutions: 'Akkreditierte Einrichtungen',
  why_stat_treatments: 'Behandlungsbereiche',
  why_stat_countries: 'Länder',
  why_stat_satisfaction: 'Patientenzufriedenheit',
  why_feature1_title: 'Akkreditierte Einrichtungen',
  why_feature1_desc: 'Alle Gesundheitseinrichtungen auf der Plattform sind verifizierte Einrichtungen mit JCI-, ISO- oder türkischer Gesundheitsministerium-Akkreditierung.',
  why_feature2_title: 'Mehrsprachige Unterstützung',
  why_feature2_desc: 'Filtern Sie einfach Einrichtungen, die Kommunikationsunterstützung auf Arabisch, Englisch, Russisch und weiteren Sprachen anbieten.',
  why_feature3_title: 'Detaillierter Vergleich',
  why_feature3_desc: 'Vergleichen Sie Einrichtungen nebeneinander nach ihren Dienstleistungen, Ärzten, Standorten und Patientenbewertungen.',
  why_feature4_title: 'Rückrufanfrage',
  why_feature4_desc: 'Senden Sie direkt eine Rückrufanfrage an die Einrichtung, die Ihnen gefällt. Die Einrichtung ruft Sie mit Sprachunterstützung an.',
  why_feature5_title: 'Erschwingliche Kosten',
  why_feature5_desc: 'Erhalten Sie Weltklasse-Gesundheitsversorgung zu 50-70% niedrigeren Preisen im Vergleich zu Europa und den USA.',
  why_feature6_title: 'Standort & Transport',
  why_feature6_desc: 'Entdecken Sie Einrichtungen in allen Städten der Türkei, insbesondere Istanbul, Ankara, Izmir und Antalya.',

  inst_approved_badge: 'Genehmigt',
  inst_explore: 'Erkunden',
  inst_doctor_count: '{{count}} Arzt',
  inst_no_approved: 'Noch keine genehmigten Einrichtungen.',
  agencies_service_badge: 'Gesundheitstourismusagentur',
  agencies_consult: 'Beratungsanfrage kann gesendet werden',
  agencies_explore: 'Erkunden',

  process_badge: 'Schritt für Schritt',
  process_title: 'IVF-',
  process_title_highlight: 'Prozess',
  process_subtitle: 'Lernen Sie jede Phase der IVF-Behandlung verständlich kennen',
  process_step_label: 'Schritt {{num}}',
  process_step1_title: 'Voruntersuchung',
  process_step1_desc: 'Ein Behandlungsplan wird mit detaillierter Untersuchung, Hormontests und Ultraschall erstellt.',
  process_step2_title: 'Eierstockstimulation',
  process_step2_desc: 'Eierstöcke werden mit Hormonmedikamenten stimuliert und die Eientwicklung überwacht.',
  process_step3_title: 'Eizellentnahme',
  process_step3_desc: 'Reife Eizellen werden unter leichter Anästhesie entnommen.',
  process_step4_title: 'Befruchtung',
  process_step4_desc: 'Ei- und Samenzellen werden in einer Laborumgebung kombiniert.',
  process_step5_title: 'Embryoentwicklung',
  process_step5_desc: 'Die gebildeten Embryonen werden 3-5 Tage im Labor entwickelt.',
  process_step6_title: 'Embryotransfer',
  process_step6_desc: 'Der qualitativ hochwertigste Embryo wird in die Gebärmutter eingesetzt und ein Schwangerschaftstest abgewartet.',

  explore_badge: 'Türkei entdecken',
  explore_title: 'Lernen Sie',
  explore_title_highlight: 'die Türkei kennen',
  explore_subtitle: 'Verpassen Sie nicht die Gelegenheit, dieses schöne Land zu erkunden, während Sie für Ihre Behandlung in die Türkei kommen.',
  explore_destinations: 'Reiseziele',
  explore_culture: 'Kultur & Leben',
  explore_about_title: 'Über die Türkei',
  explore_about_subtitle: 'Städte, Reiseziele & Praktische Infos',
  explore_about_desc: 'Die historische Halbinsel Istanbuls, die Ägäisküste Izmirs, das türkisfarbene Wasser Antalyas und mehr. Entdecken Sie die schönsten Reiseziele der Türkei.',
  explore_about_highlights: 'Istanbul,Izmir,Antalya,Kappadokien',
  explore_culture_title: 'Kultur in der Türkei',
  explore_culture_subtitle: 'Etikette, Küche & Traditionen',
  explore_culture_desc: 'Türkische Gastfreundschaft, Teekultur, köstliche Küche und reiche Traditionen. Alles, was Sie wissen müssen, bevor Sie in die Türkei kommen.',
  explore_culture_highlights: 'Türkische Küche,Etikette,Traditionen,Soziales Leben',
  explore_cta: 'Erkunden',
  explore_stat1: '81 Provinzen, Unzählige Reiseziele',
  explore_stat2: 'Reiche türkische Küche',
  explore_stat3: '10.000 Jahre Geschichte',

  faq_badge: 'Wissensbibliothek',
  faq_title: 'Häufig gestellte',
  faq_title_highlight: 'Fragen',
  faq_subtitle: 'Neugierige Fragen zum IVF-Prozess',
  faq_q1: 'Was ist IVF-Behandlung und wie funktioniert sie?',
  faq_a1: 'IVF (In-vitro-Fertilisation) ist der Prozess, bei dem Ei- und Samenzellen in einer Laborumgebung kombiniert und der resultierende Embryo in die Gebärmutter der Mutter eingesetzt wird. Der Behandlungsprozess besteht aus Hormontherapie, Eizellentnahme, Befruchtung und Embryotransfer.',
  faq_q2: 'Wie lange dauert die IVF-Behandlung?',
  faq_a2: 'Ein IVF-Behandlungszyklus dauert durchschnittlich 4-6 Wochen. Dieser Zeitraum umfasst Vorbereitung, Hormontherapie, Eizellentnahme und Embryotransfer. Die Dauer kann jedoch variieren, da jede Patientensituation unterschiedlich ist.',
  faq_q3: 'Wie hoch ist die Erfolgsrate der IVF-Behandlung?',
  faq_a3: 'Die Erfolgsrate hängt von Faktoren wie Alter, Eizellqualität, Spermienqualität und allgemeinem Gesundheitszustand ab. Bei Frauen unter 35 liegt die Erfolgsrate bei etwa 40-50% und nimmt mit dem Alter ab.',
  faq_q4: 'Ist die IVF-Behandlung schmerzhaft?',
  faq_a4: 'Der größte Teil des Behandlungsprozesses ist schmerzlos. Die Eizellentnahme wird unter leichter Anästhesie durchgeführt und das Unbehagen ist minimal. Der Embryotransfer ist ein schmerzloser Eingriff.',
  faq_q5: 'Gibt es eine Altersgrenze für die IVF-Behandlung?',
  faq_a5: 'In der Türkei liegt die gesetzliche Altersgrenze für IVF-Behandlung bei 18-49 Jahren für Frauen und 18-60 Jahren für Männer. Da die Erfolgsrate mit dem Alter abnimmt, ist es vorteilhafter, die Behandlung besonders unter 35 Jahren zu beginnen.',
  faq_q6: 'Was kostet die IVF-Behandlung?',
  faq_a6: 'Die Kosten variieren je nach gewähltem Zentrum, Behandlungsprotokoll und Medikamenteneinsatz. In der Türkei liegt der Durchschnitt zwischen 15.000-30.000 TL. Einige private Krankenversicherungen können teilweise Deckung bieten.',

  // Behandlungsleistungen
  treat_sac_ekimi_title: 'Haartransplantation',
  treat_sac_ekimi_subtitle: 'FUE / DHI Technik',
  treat_sac_ekimi_desc: 'Einer der weltweit beliebtesten Gesundheitstourismus-Dienste. Dauerhafte und natürliche Ergebnisse.',
  treat_sac_ekimi_tag: 'Am beliebtesten',
  treat_dis_tedavisi_title: 'Zahnbehandlung',
  treat_dis_tedavisi_subtitle: 'Implantat / Veneer / Zirkonium',
  treat_dis_tedavisi_desc: 'Die Türkei ist Europas beliebtestes Ziel für ästhetische Zahnheilkunde und Implantatbehandlung.',
  treat_dis_tedavisi_tag: 'Sehr beliebt',
  treat_goz_ameliyati_title: 'Augenoperation',
  treat_goz_ameliyati_subtitle: 'LASIK / LASEK / Linse',
  treat_goz_ameliyati_desc: 'Permanente Sehlösungen mit Fachkliniken für Laseraugenoperationen und Intraokularlinsen.',
  treat_goz_ameliyati_tag: '',
  treat_estetik_cerrahi_title: 'Ästhetische Chirurgie',
  treat_estetik_cerrahi_subtitle: 'Rhinoplastik / Liposuktion / BBL',
  treat_estetik_cerrahi_desc: 'Sichere und qualitativ hochwertige Operationen mit erfahrenen Spezialisten der plastischen Chirurgie.',
  treat_estetik_cerrahi_tag: 'Hohe Nachfrage',
  treat_ortopedi_title: 'Orthopädie & Traumatologie',
  treat_ortopedi_subtitle: 'Knie / Hüfte / Wirbelsäule',
  treat_ortopedi_desc: 'Erfahrene orthopädische Zentren für Gelenkersatz, Wirbelsäulenchirurgie und Sportverletzungen.',
  treat_ortopedi_tag: '',
  treat_tup_bebek_title: 'IVF-Behandlung',
  treat_tup_bebek_subtitle: 'IVF / ICSI / PGT',
  treat_tup_bebek_desc: 'Verwirklichen Sie Ihren Traum von einer Familie mit akkreditierten IVF-Zentren der Türkei.',
  treat_tup_bebek_tag: '',
  treat_kardiyoloji_title: 'Kardiologie',
  treat_kardiyoloji_subtitle: 'Herzchirurgie / Angiographie',
  treat_kardiyoloji_desc: 'Kardiologiezentren mit weltklasse Service bei der Behandlung von Herz-Kreislauf-Erkrankungen.',
  treat_kardiyoloji_tag: '',
  treat_onkoloji_title: 'Onkologie',
  treat_onkoloji_subtitle: 'Krebsbehandlung / Strahlentherapie',
  treat_onkoloji_desc: 'Ein hoffnungsvoller Prozess mit Onkologiezentren, die modernste Methoden in der Krebsbehandlung nutzen.',
  treat_onkoloji_tag: '',
  treat_obezite_title: 'Adipositaschirurgie',
  treat_obezite_subtitle: 'Magenverkleinerung / Bypass',
  treat_obezite_desc: 'Machen Sie mit Spezialistenteams in der Adipositas- und Stoffwechselchirurgie einen Schritt in ein gesundes Leben.',
  treat_obezite_tag: '',
  treat_checkup_title: 'Check-up & Screening',
  treat_checkup_subtitle: 'Umfassendes Gesundheits-Screening',
  treat_checkup_desc: 'Schützen Sie Ihre Gesundheit mit Frühdiagnose und umfassenden Gesundheits-Screening-Paketen.',
  treat_checkup_tag: '',
  treat_noroloji_title: 'Neurologie & Gehirnchirurgie',
  treat_noroloji_subtitle: 'Gehirn / Nervensystem',
  treat_noroloji_desc: 'Umfassende Behandlung mit Fachzentren für neurologische Erkrankungen und Gehirnchirurgie.',
  treat_noroloji_tag: '',
  treat_uroloji_title: 'Urologie',
  treat_uroloji_subtitle: 'Niere / Blase / Prostata',
  treat_uroloji_desc: 'Sichere Lösungen mit Fachkliniken bei der Diagnose und Behandlung urologischer Erkrankungen.',
  treat_uroloji_tag: '',
  treat_dermatoloji_title: 'Dermatologie',
  treat_dermatoloji_subtitle: 'Haut / Laser / Ästhetik',
  treat_dermatoloji_desc: 'Gesunde Haut mit Fachkliniken für Hauterkrankungen und ästhetische Dermatologie.',
  treat_dermatoloji_tag: '',
  treat_fizik_tedavi_title: 'Physiotherapie',
  treat_fizik_tedavi_subtitle: 'Rehabilitation / Physiotherapie',
  treat_fizik_tedavi_desc: 'Schnelle Genesung mit Fachzentren für Physio- und Rehabilitationstherapie.',
  treat_fizik_tedavi_tag: '',
  treat_organ_nakli_title: 'Organtransplantation',
  treat_organ_nakli_subtitle: 'Niere / Leber / Herz',
  treat_organ_nakli_desc: 'Ein neues Leben mit erfahrenen Transplantationszentren.',
  treat_organ_nakli_tag: '',

  cta_badge: 'Für Einrichtungen',
  cta_title: 'Fügen Sie Ihre Gesundheitseinrichtung',
  cta_title_highlight: 'zur Plattform hinzu',
  cta_subtitle: 'Erreichen Sie mehr Patienten. Bewerben Sie Ihre Einrichtung mit kostenloser oder Pro-Mitgliedschaft, erhalten Sie Beratungsanfragen und stärken Sie Ihre Online-Präsenz.',
  cta_register: 'Einrichtungskonto erstellen',
  cta_more_info: 'Mehr Informationen',
  cta_stat_centers: 'Registrierte Zentren',
  cta_stat_consultations: 'Beratungsanfragen',
  cta_stat_completed: 'Abgeschlossene Beratungen',
  cta_stat_cities: 'Städte',
};

export default home;
